import {connect} from 'react-redux';
import InfoPanel from './InfoPanel';
import {getShumaBasicData} from '../../actions/getShumaBasicData';
import {showGlobalErrorMessage} from '../../../../common/actions/globalErrorMessage/showGlobalErrorMessage';

export default connect(
  null,
  {getShumaBasicData, showGlobalErrorMessage}
)(InfoPanel);
